
import { Component, Prop, Vue } from 'vue-property-decorator';
import { translate } from '@/helpers/functions';
import stores from '@/stores/index';
import MultiSelect from 'vue-multiselect';

@Component({
  components: {
    MultiSelect,
  }
})
export default class RemoteImport extends Vue {
  @Prop() module!: any;
  @Prop() moduleType!: string;
  @Prop({ default: function() {} }) onRefresh!: Function;

  // Service providers
  serviceProviders = [
    { id: 'ott-tel', name: 'OTT Tel'} // Telekom Slovenia OTT Tel service
  ];
  selectedService = 'ott-tel';

  clientIp = '';
  isImporting = false;
  selectedPackageId: number | null = null;
  selectedCategoryIds: number[] = [];
  packageOptions: Array<{value: number | null, text: string}> = [];
  categoryOptions: Array<{value: number, text: string}> = [];

  get isSuperAdmin(): boolean {
    return stores.admin &&
           stores.admin.permissions &&
           stores.admin.permissions.includes('global-settings.PRIVILEGED_EDITOR');
  }

  openRemoteImportModal() {
    this.loadPackagesAndCategories();
    (this.$refs.remoteImportModal as any).show();
  }

  async loadPackagesAndCategories() {
    try {
      if (!this.module || !this.module.id) {
        console.error('Module not available');
        return;
      }

      const tvModule = this.module;

      // For packages - using the global Package store
      try {
        const packagesResponse = await stores.Package.getAllPackages();
        if (packagesResponse && packagesResponse) {
          this.packageOptions = packagesResponse.map((pkg: any) => ({
            value: pkg.id,
            text: translate(pkg.name)
          }));
        } else {
          this.packageOptions = [];
        }
      } catch (e) {
        console.error('Error getting packages:', e);
        this.packageOptions = [];
      }

      // For categories
      try {
        const categoriesResponse = await tvModule.getAllCategories();
        if (categoriesResponse && categoriesResponse.data) {
          this.categoryOptions = categoriesResponse.data.map((category: any) => ({
            value: category.id,
            text: translate(category.name)
          }));
        } else {
          this.categoryOptions = [];
        }
      } catch (e) {
        console.error('Error getting categories:', e);
        this.categoryOptions = [];
      }
    } catch (error) {
      console.error('Failed to load packages or categories:', error);
      this.packageOptions = [];
      this.categoryOptions = [];
    }
  }

  async handleRemoteImport(bvModalEvt?: any) {
    // Prevent modal from closing automatically
    if (bvModalEvt) {
      bvModalEvt.preventDefault();
    }

    this.isImporting = true;

    try {
      let importData = {
        module_id: this.module.id,
        service: this.selectedService,
        client_ip: this.clientIp,
        package_ids: this.selectedPackageId,
        category_ids: this.selectedCategoryIds
      };

      const response = await this.module.remoteImport(importData);

      if (response.success) {
        (this as any).$bvToast.toast(translate('import-succesfull'), {
          title: 'Success',
          variant: 'success',
          solid: true
        });
        // Close modal only on success
        (this.$refs.remoteImportModal as any).hide();
        this.resetForm();
        // Refresh the channels list
        this.onRefresh();
      } else {
        (this as any).$bvToast.toast(response.message || 'Import failed', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    } catch (error) {
        console.error('Remote import error:', error);

        // Check if it's a 403 error (permission denied)
        if ((error as any).response && (error as any).response.status === 403) {
            (this as any).$bvToast.toast(
                translate('super-admin-required') || 'Permission denied. Super admin access required.',
                {
                    title: translate('access-denied') || 'Access Denied',
                    variant: 'danger',
                    solid: true
                }
            );
            (this.$refs.remoteImportModal as any).hide();
        } else {
            (this as any).$bvToast.toast(
                (error as any).response?.data?.message || 'Import failed. Please check the URL and try again.',
                {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                }
            );
        }
    } finally {
        this.isImporting = false;
    }
  }

  cancelImport() {
    (this.$refs.remoteImportModal as any).hide();
    this.resetForm();
  }

  resetForm() {
    this.selectedService = '';
    this.clientIp = '';
    this.selectedPackageId = null;
    this.selectedCategoryIds = [];
  }
}
